
import Vue from 'vue'
import { IWpUser } from '@interfaces/WpTypes'

export default Vue.extend({
  name: 'BlogSinglePostAuthor',
  props: {
    author: {
      type: Object as Vue.PropType<IWpUser>,
      default: {},
    },
  },
})
